export const NON_MEMBER_SUBSCRIBE_FORM = 'nonMemberSubscribeForm'
